export default __webpack_public_path__ + "static/media/keto_concentrate@3x.c31bb370.jpg";